import React from 'react';

import { Add as AddIcon } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

import { Modal, ModalTopAction } from 'src/components/common';

export const ModalSection: React.FC = () => {
  const [currentModal, setCurrentModal] = React.useState<number>();

  const handleModalClose = React.useCallback(() => {
    setCurrentModal(undefined);
  }, []);

  const renderModalContent = () => {
    return (
      <React.Fragment>
        <Typography variant="body1">{loremIpsum}</Typography>
        <Box mt={4}>
          <Button variant="outlined" color="error" onClick={handleModalClose}>
            Close
          </Button>
        </Box>
      </React.Fragment>
    );
  };

  return (
    <Box component="section">
      <Typography variant="h3">Modal</Typography>

      <Box display="flex" gap={2} mt={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setCurrentModal(ModalId.simpleModal)}
        >
          Simple Modal
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={() => setCurrentModal(ModalId.modalWithMaxWidth)}
        >
          Modal with max width
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={() => setCurrentModal(ModalId.modalWithAction)}
        >
          Modal with action
        </Button>
      </Box>

      <Modal
        title="Simple Modal"
        dialogProps={{ open: currentModal === ModalId.simpleModal, onClose: handleModalClose }}
      >
        {renderModalContent()}
      </Modal>

      <Modal
        title="Modal with max width (480px)"
        dialogProps={{
          open: currentModal === ModalId.modalWithMaxWidth,
          onClose: handleModalClose,
        }}
        maxWidth={480}
      >
        {renderModalContent()}
      </Modal>

      <Modal
        title="Modal with action"
        dialogProps={{
          open: currentModal === ModalId.modalWithAction,
          onClose: handleModalClose,
        }}
        topAction={topAction}
      >
        {renderModalContent()}
      </Modal>
    </Box>
  );
};

enum ModalId {
  simpleModal = 1,
  modalWithMaxWidth,
  modalWithAction,
}

const loremIpsum =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

const topAction: ModalTopAction = {
  actionName: 'Create',
  show: true,
  icon: <AddIcon />,
};
